@if(reminderList.length) {
  <div class="reminder-tags"
  [style]="{
    'max-height': getMaxHeight()
  }">
    @for(item of reminderList; track index; let index = $index) {
      <div class="tag" [class]="{ send: item.status === ReminderStatus.Sent }">
        <i class="icon ic-checkmark-16" [hidden]="item.status !== ReminderStatus.Sent"></i>
        <span>{{ item.scheduledOn | dateFormat}}</span>
      </div>
    }
  </div>
}